import { createSelector } from 'reselect';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getChatflowConnectionStatuses } from './getChatflowConnectionStatuses';
import { getChatflowIdFromProps } from './chatflowSelectors';
export const getChatflowConnectionStatus = createSelector([getChatflowIdFromProps, getChatflowConnectionStatuses], (chatflowId, chatflowConnectionStatuses) => {
  // @ts-expect-error IndexedAsyncData is not typed properly with idTransform
  if (chatflowId) return getEntry(chatflowId, chatflowConnectionStatuses);
  return null;
});